module.exports = __webpack_public_path__ + "static/media/php.a6ce9f3d.svg";